
<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="panel-heading">
      <span v-if="route === 'ActiveFacilities'"><h4 class="earth-color">ACTIVE ACCOMMODATIONS AND CAMPING</h4></span>
      <span v-else><h4 class="earth-color">ACCOMMODATIONS AND CAMPING</h4></span>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
        class="futuristic-input"
        outlined
      ></v-text-field>
    </v-card-title>
    <hr class="futuristic-divider" />
    <v-data-table
      :headers="columns"
      :items="allFacilities"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="futuristic-table-cell">{{ formated_date_time(props.item.created_at)}}</td>
        <td class="futuristic-table-cell">{{ props.item.code}}</td>
        <td class="futuristic-table-cell">{{ props.item.analysis_code}}</td>
        <td class="futuristic-table-cell">{{ props.item.outlet_analysis_code}}</td>
        <td class="futuristic-table-cell">{{ props.item.facility_type_id}}</td>
        <td class="futuristic-table-cell">{{ props.item.accomodation_type_id}}</td>
        <td class="futuristic-table-cell">{{ props.item.name}}</td>
        <td class="futuristic-table-cell">{{ props.item.maximum_guests}} </td>
        <td class="futuristic-table-cell">{{ getPricingStatus(props.item.pricing_status) }} </td>
        <td class="futuristic-table-cell">
          <span v-if="props.item.has_revenue_split">Yes</span>
          <span v-else>No</span>
        </td>
        <td class="futuristic-table-cell">
          <span v-if="props.item.thumbnail === null">Not Set</span>
          <span v-else>Set</span>
        </td>
        <td class="has-text-right">
          <v-btn
            :depressed="true"
            small
            color="primary"
            v-on:click="viewUser(props.item.public_id)"
            class="futuristic-btn"
          >View Details</v-btn>
        </td>
      </template>
      <template slot="footer">
        <td :colspan="columns.length">
          <vue-json-to-csv
            :json-data="allFacilities"
            csv-title="Accommodation List"
            :labels="{
              facility_type_id: { title: 'Accommodation Category'},
              accomodation_type_id: { title: 'Accommodation Type'},
              name: { title: 'Accommodation Name'},
              code: { title: 'Income Account Code'},
              analysis_code: { title: 'Department Code'},
              outlet_analysis_code: { title: 'Outlet Code'},
              google_analytics_code: { title: 'Google Analytics Code'},
              pricing_status: { title: 'Pricing Status'},
              vat: { title: 'VAT'},
              catering_levy: { title: 'Catering Levy'},
              unavailability_schedule_set: { title: 'Unavailability Schedule Set'},
              discount_status: { title: 'Discount Status'},
              has_revenue_split: { title: 'Has Revenue Split'},
            }"
          >
            <v-btn class="futuristic-btn">
              <b>Download CSV</b>
            </v-btn>
          </vue-json-to-csv>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
export default {
  components: { VueJsonToCsv },
  data () {
    return {
      search: '',
      route: this.$route.name,
      columns: [
        {
          text: 'Created on',
          value: 'created_at'
        },
        {
          text: 'Income Account Code',
          value: 'code'
        },
        {
          text: 'Department Code',
          value: 'analysis_code'
        },
        {
          text: 'Outlet Code',
          value: 'outlet_analysis_code'
        },
        {
          text: 'Accommodation Category',
          value: 'facility_type_id'
        },
        {
          text: 'Accommodation Type',
          value: 'accomodation_type_id'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Maximum Guests',
          value: 'maximum_guests'
        },
        {
          text: 'Pricing Set',
          value: 'pricing_status'
        },
        {
          text: 'Has Split Revenue',
          value: 'has_revenue_split'
        },
        {
          text: 'Image Set'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_active_facilities')
  },
  methods: {
    getPricingStatus (status) {
      if (status === 'false') {
        return 'Not Set'
      } else {
        return 'Set'
      }
    },
    viewUser: function (publicId) {
      this.$router.push({
        name: 'Facility',
        params: {
          facility_id: publicId
        }
      })
    }
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.panel-heading {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

.futuristic-divider {
  border: 0;
  height: 1px;
  background: linear-gradient(to right, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.8), rgba(76, 175, 80, 0.2));
  margin: 8px 0 16px;
}

/* Search Input */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-input >>> .v-text-field__slot input {
  color: #333;
}

/* Data Table */
.futuristic-table {
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-table >>> .v-datatable__thead th {
  color: #4caf50;
  font-weight: 600;
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-table-cell {
  color: #333;
  padding: 12px;
}

/* Button Styling */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Alert Styling */
.futuristic-alert {
  border-radius: 8px;
  background: #ffebee;
  color: #c62828;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .panel-heading {
    padding: 12px;
  }

  .futuristic-btn {
    margin: 2px;
    font-size: 0.9rem;
  }

  .futuristic-table-cell {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .panel-heading {
    border-radius: 6px 6px 0 0;
  }

  .futuristic-input >>> .v-input__slot {
    border-radius: 6px;
  }

  .futuristic-btn {
    border-radius: 6px;
    width: 100%;
    margin: 4px 0;
  }

  .futuristic-table >>> .v-datatable__thead th {
    font-size: 0.9rem;
  }

  .futuristic-table-cell {
    font-size: 0.85rem;
    padding: 6px;
  }
}
</style>
